import dayjs from 'dayjs'

const isSameOrAfter = require("dayjs/plugin/isSameOrAfter");
dayjs.extend(isSameOrAfter);

const isSameOrBefore = require("dayjs/plugin/isSameOrBefore");
dayjs.extend(isSameOrBefore);

const arraySupport = require("dayjs/plugin/arraySupport");
dayjs.extend(arraySupport);

const timezone = require("dayjs/plugin/timezone");
dayjs.extend(timezone);

const duration = require("dayjs/plugin/duration");
dayjs.extend(duration);

// const badMutable = require("dayjs/plugin/badMutable");
// dayjs.extend(badMutable);

const utc = require('dayjs/plugin/utc');
dayjs.extend(utc);

export default dayjs.tz;



// WEBPACK FOOTER //
// ./src/addon/dayjs.js